// chips and segmented keys show their state with an `active` class, which a screen reader cannot see. this mirrors
// that class into aria-pressed so views keep toggling a class and every toggle button still says on or off.
// a button a view already gives its own aria-pressed or role is left alone

const TOGGLES = "button.chip, button.seg-option, button.switch-option";
const mirrored = new WeakSet<Element>();

function mirror(el: Element): void {
  if (!el.matches(TOGGLES)) return;
  if (!mirrored.has(el) && (el.hasAttribute("aria-pressed") || el.hasAttribute("role") || el.hasAttribute("aria-selected"))) return;
  mirrored.add(el);
  const on = String(el.classList.contains("active"));
  if (el.getAttribute("aria-pressed") !== on) el.setAttribute("aria-pressed", on);
}

function scan(root: ParentNode): void {
  if (root instanceof Element) mirror(root);
  root.querySelectorAll(TOGGLES).forEach(mirror);
}

export function setupAriaSync(): void {
  scan(document.body);
  new MutationObserver((records) => {
    for (const record of records) {
      if (record.type === "attributes") mirror(record.target as Element);
      else record.addedNodes.forEach((node) => node instanceof Element && scan(node));
    }
  }).observe(document.body, { subtree: true, childList: true, attributes: true, attributeFilter: ["class"] });
}
